import { assertEnv } from "../env/assert-env";
import { apiPost } from "./api-tools";

export function getServiceInquiryConfig() {
  const apiKey = assertEnv(
    "SERVICE_INQUIRY_FUNCTION_KEY",
    process.env.SERVICE_INQUIRY_FUNCTION_KEY,
  );
  const url = assertEnv("SERVICE_INQUIRY_URL", process.env.SERVICE_INQUIRY_URL);
  return { apiKey, url } as const;
}

// note: inject the CareSeekerLeadFormResponse type when you call this,
// we should handle it here directly but we need to refactor some other stuff first (zod schemas, types)
//
// New `step4.source` values must be allowed by the Service Inquiry API / downstream Salesforce flow — coordinate with platform owners.
export async function postServiceInquiry<T>(formData: Record<string, unknown>) {
  const { apiKey, url } = getServiceInquiryConfig();
  return apiPost<T>(
    url,
    {
      body: JSON.stringify(formData),
    },
    {
      apiKey,
    },
  );
}
